import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { setCodes, setLoading, setError, resetCodes, resetShowCodes } from "../store/slices/recoveryCode/RecoveryCodeSlice";
import RecoveryCodeService from "../services/RecoveryCodeService";

export const useRecoveryCodes = () => {
    const dispatch = useDispatch();
    const { codes, showCodes, generated, loading, error } = useSelector((state: RootState) => state.recoveryCodes);

    const generateRecoveryCodes = async (email: string) => {
        dispatch(setLoading(true));
        try {
            const codes = await RecoveryCodeService.generateCodes(email);
            dispatch(setCodes(codes));
        } catch (error: any) {
            dispatch(setError(error.message));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleResetCodes = () => {
        dispatch(resetCodes());
    }

    const handleResetShowCodes = () => {
        dispatch(resetShowCodes());
    }

    return { codes, showCodes, generated, loading, error, generateRecoveryCodes, handleResetCodes, handleResetShowCodes };
};
